import script from "./videoManage.vue?vue&type=script&setup=true&lang=js"
export * from "./videoManage.vue?vue&type=script&setup=true&lang=js"

import "./videoManage.vue?vue&type=style&index=0&id=d0b01f52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0b01f52"]])

export default __exports__